import React from "react";
import AddContact from "../component/contacts/createContact";
import * as clientAction from "../../../redux/actions/clientAction";

import * as projectAction from "../../../redux/storm-water/actions/projectAction";

import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import * as stateCityAction from "../../../redux/actions/stateCityAction";
import * as contactsAction from "../../../redux/actions/contactsAction";
import Loader from "../../../library/common/Loader";
import SuccessScreen from "../../../library/custom/success/successScreen";
import { ACCESS_DENIED, ADMIN_CONTACTS } from "../../../constant/routeContant";
import { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useDebounce } from "../../../utils/useDebounceSearch";

import {
  notifyError,
  notifyErrorContactContractor,
} from "../../../../src/library/custom/toastMessage/Toast";
import { ToastContainer } from "react-toastify";
import {
  API_STATUS,
  LOGIN_ORG_ID,
  ORG_ID,
  PAGE_SIZE,
} from "../../../constant/constant";
import * as adminAction from "../../../redux/actions/adminCommonAction";
import { PRODUCT_ID } from "../../../constant/storm-water/constant";
import { checkPrivileges } from "../../../utils/rolesHelper";
import * as userAction from "../../../redux/actions/userAction";
import BackBtn from "../../../library/custom/backBtn/backBtn";

export default function AddContactsContainer() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [customerId, setCustomerId] = useState(0);
  const stateData = useSelector((state) => state.state);
  const cityData = useSelector((state) => state.city);
  const contactData = useSelector((state) => state.createContact);
  const [successScreens, setSuccessScreens] = useState(false);
  const [isConvert, setIsConvert] = useState(false);
  const [convertPayload, setConvertPayload] = useState(null);
  const [isAddingProject, setIsAddingProject] = useState(false);
  const getSwProjectDetailData = useSelector(
    (state) => state.getSwProjectDetail,
  );

  const getSwProjectDetailDatanew = useSelector((state) => state.viewContacts);

  const userInfo = JSON.parse(localStorage.getItem("userInfo"));
  const product = userInfo?.product;
  const roles = useSelector(
    (state) => state.getDropdownDataKeyValue?.data?.roles,
  );
  const divisions = useSelector(
    (state) => state.getDropdownDataKeyValue?.data?.divisons,
  );
  const [resetAllClients, setResetAllClients] = useState([]);
  const [resetAllProjects, setResetAllProjects] = useState([]);
  const [clientSearchText, setClientSearchText] = useState("");
  const debouncedClientSearch = useDebounce(clientSearchText, 500);
  const [projectSearchText, setProjectSearchText] = useState("");
  const debouncedProjectSearch = useDebounce(projectSearchText, 500);

  const location = useLocation();
  const contactId = location?.state?.contactId;
  const editMode = location?.state?.editMode;

  const viewContactData = useSelector((state) => state?.viewContacts?.data);
  const updateContact = useSelector((state) => state.updateContact);
  const convertNonPrivilegeContactListData = useSelector(
    (state) => state.convertNonPrivilegeContactListData,
  );

  const allClients = useSelector((state) => state.searchAllClientsReducerData);

  const isSearchClientLoading = allClients?.isLoading;

  const searchClient = (event) => {
    setResetAllClients([]);
    setClientSearchText(event.target.value);
  };

  const getCity = (stateId) => {
    dispatch(stateCityAction.getCity(stateId));
  };
  const [setsubmit, setSetsubmit] = useState(false);

  const getStateData = () => {
    dispatch(stateCityAction.getState());
  };

  useEffect(() => {
    if (debouncedClientSearch !== undefined) {
      dispatch(clientAction.searchAllClients(debouncedClientSearch));
    }
  }, [debouncedClientSearch, dispatch]);

  useEffect(() => {
    dispatch(projectAction?.getProjectDetailsReset());
  }, [location.pathname]);

  const showLoader = useSelector(
    (state) =>
      state.createContact?.isLoading ||
      state.stateData?.isLoading ||
      state?.viewContacts?.isLoading ||
      state.updateContact?.isLoading ||
      state.state?.isLoading ||
      state.convertNonPrivilegeContactListData?.isLoading ||
      state.sendEmailVerificationReducerData.isLoading,
  );

  const getDropdownDataKeyValueData = {
    orgId: ORG_ID(),
    flags: "5,6",
    productId: PRODUCT_ID(),
  };
  useEffect(() => {
    getStateData();
    dispatch(adminAction.getDropdownDataKeyValue(getDropdownDataKeyValueData));
  }, []);

  useEffect(() => {
    setSuccessScreens(false);
    dispatch(contactsAction.clearContact());
    if (contactId) {
      dispatch(contactsAction.getContactDetails(contactId));
    }
  }, [dispatch]);

  const addAndUpdateContact = (data, checkBoxPrivilege) => {
    setSuccessScreens(true);
    setIsConvert(checkBoxPrivilege);
    if (editMode) {
      if (checkBoxPrivilege) {
        // Save updated details first, then convert to privileged user.
        setSetsubmit(true);
        setConvertPayload(data.convertData);
        dispatch(contactsAction.updateContact(data.updateData));
      } else {
        setSetsubmit(true);
        dispatch(contactsAction.updateContact(data));
      }
    } else {
      setSetsubmit(true);
      dispatch(contactsAction.createContact(data));
    }
  };

  const successScreen = (id, message) => {
    return (
      <SuccessScreen
        isUpdate={message}
        route={-1}
        label1=" "
        label2=" "
        label4=" Contact List in"
      ></SuccessScreen>
    );
  };

  useEffect(() => {
    if (
      contactData?.status === API_STATUS.FAILURE ||
      updateContact?.status === API_STATUS.FAILURE ||
      convertNonPrivilegeContactListData?.status === API_STATUS.FAILURE
    ) {
      notifyError();
    } else {
      if (contactData?.status === API_STATUS.SUCCESS) {
        if (
          contactData?.data?.responseMessages?.responseCode == "HBNG006" &&
          setsubmit
        ) {
          notifyErrorContactContractor();
        }

        if (
          contactData?.data?.responseMessages?.responseCode == "HBNG001" &&
          setsubmit
        ) {
          //setIsSuccess(true);
          setSuccessScreens(true);
        }
      }

      if (updateContact?.status === API_STATUS.SUCCESS) {
        if (
          updateContact?.data?.responseMessages?.responseCode == "HBNG006" &&
          setsubmit
        ) {
          notifyErrorContactContractor();
        }
        if (
          updateContact?.data?.responseMessages?.responseCode == "HBNG001" &&
          setsubmit
        ) {
          //setIsSuccess(true);
          setSuccessScreens(true);
        }
      }
    }
  }, [contactData, updateContact]);

  useEffect(() => {
    if (convertNonPrivilegeContactListData?.status === API_STATUS.SUCCESS) {
      if (
        convertNonPrivilegeContactListData?.data?.responseMessages
          ?.responseCode == "HBNG006" &&
        setsubmit
      ) {
        notifyErrorContactContractor();
      }
    }
    if (convertNonPrivilegeContactListData?.status === API_STATUS.SUCCESS) {
      if (
        convertNonPrivilegeContactListData?.data?.responseMessages
          ?.responseCode == "HBNG001" &&
        setsubmit
      ) {
        setSuccessScreens(true);
      }
    }
  }, [convertNonPrivilegeContactListData, contactData, updateContact]);

  useEffect(() => {
    // Convert flow: once the detail update succeeds, fire the convert API.
    if (
      isConvert &&
      convertPayload &&
      updateContact?.status === API_STATUS.SUCCESS &&
      updateContact?.data?.responseMessages?.responseCode == "HBNG001"
    ) {
      dispatch(contactsAction.convertNonPrivilegeContactList(convertPayload));
      setConvertPayload(null);
    }
  }, [updateContact, isConvert, convertPayload]);

  const sendEmailVerification = (data) => {
    dispatch(userAction.postSendEmailVerification(data));
  };

  const handleAllProjectSearch = (event, value, orgId) => {
    setResetAllProjects([]);
    setProjectSearchText(event.target.value);
    setCustomerId(orgId ? orgId : ORG_ID() != LOGIN_ORG_ID ? ORG_ID() : orgId);
  };

  useEffect(() => {
    if (!customerId) return;

    const defaultProjectData = {
      page: 1,
      pageSize: PAGE_SIZE,
      customerId,
      startDate: "",
      endDate: "",
      search: debouncedProjectSearch || "",
      siteId: "",
      status: "",
    };

    dispatch(projectAction.swProjectList(defaultProjectData));
  }, [debouncedProjectSearch, customerId, dispatch]);

  const getProjectDetails = (data) => {
    const payload = {
      projectId: data,
    };
    dispatch(projectAction.getProjectDetails(payload));
  };
  const allProjects = useSelector((state) => state?.swprojectList);

  const isProjectLoading = allProjects?.isLoading;

  useEffect(() => {
    if (allProjects?.status === API_STATUS.SUCCESS) {
      setResetAllProjects(allProjects?.data?.projects);
    }
  }, [allProjects?.data?.projects]);
  useEffect(() => {
    if (allClients?.status === API_STATUS.SUCCESS) {
      setResetAllClients(allClients?.data);
    }
  }, [allClients?.data]);

  const dataBack = {
    title: "Back to Contacts",
    route: ADMIN_CONTACTS,
  };

  return (
    <>
      {<BackBtn dataBack={dataBack} />}
      {checkPrivileges([12, 40, 41]) ? (
        <>
          {(showLoader || isAddingProject) && <Loader />}
          {convertNonPrivilegeContactListData.status === "SUCCESS" &&
          convertNonPrivilegeContactListData.data &&
          successScreens &&
          convertNonPrivilegeContactListData?.data?.responseMessages
            ?.responseCode == "HBNG001" ? (
            successScreen(
              convertNonPrivilegeContactListData?.data?.id,
              "Contact Converted into Privilege User Successfully",
            )
          ) : contactData.status === "SUCCESS" &&
            contactData.data &&
            successScreens &&
            contactData?.data?.responseMessages?.responseCode == "HBNG001" ? (
            successScreen(contactData?.data?.id, "Contact Created Successfully")
          ) : updateContact.status === "SUCCESS" &&
            updateContact?.data &&
            successScreens &&
            !isConvert &&
            updateContact?.data?.responseMessages?.responseCode == "HBNG001" ? (
            successScreen(
              updateContact?.data?.id,
              "Contact Updated Successfully",
            )
          ) : (
            <>
              <div>
                <ToastContainer />
              </div>
              <div>
                <AddContact
                  onSubmit={addAndUpdateContact}
                  getCity={getCity}
                  city={cityData && cityData.data?.cities}
                  state={stateData && stateData.data?.getState}
                  viewContactData={editMode ? viewContactData?.result : ""}
                  editMode={editMode}
                  contactId={contactId}
                  products={product}
                  roles={roles}
                  divisions={divisions}
                  sendEmailVerification={sendEmailVerification}
                  searchClient={searchClient}
                  allClients={allClients?.data}
                  isSearchClientLoading={isSearchClientLoading}
                  handleAllProjectSearch={handleAllProjectSearch}
                  allProjects={allProjects?.data?.projects}
                  getProjectDetails={getProjectDetails}
                  isProjectLoading={isProjectLoading}
                  getProjectDetailsdata={getSwProjectDetailData?.data?.result}
                  getProjectDetailsdatanew={
                    getSwProjectDetailDatanew?.data?.result
                  }
                  updateContact={updateContact}
                  contactData={contactData}
                  setIsAddingProject={setIsAddingProject}
                  resetAllProjects={resetAllProjects}
                  resetAllClients={resetAllClients}
                />
              </div>
            </>
          )}
        </>
      ) : (
        navigate(ACCESS_DENIED)
      )}
    </>
  );
}
